import { ADD_HOMEOSINIATRIA } from "./types";

export const agregarHomeosiniatria = (payload) => {
  return { type: ADD_HOMEOSINIATRIA, payload: payload };
};
